var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 16.5C16.2812 16.5 17.5 17.9062 17.5 19.5C17.5 21.1875 16.1875 22.5 14.5938 22.5C13 22.5 11.6875 21.1875 11.6875 19.5C11.6875 17.9062 12.9062 16.5 14.5938 16.5ZM25.0938 16.5C26.7812 16.5 28 17.9062 28 19.5C28 21.1875 26.7812 22.5 25.0938 22.5C23.4062 22.5 22.0938 21.1875 22.0938 19.5C22.0938 17.9062 23.4062 16.5 25.0938 16.5ZM35.5938 16.5C37.2812 16.5 38.5 17.9062 38.5 19.5C38.5 21.1875 37.1875 22.5 35.5938 22.5C34 22.5 32.6875 21.1875 32.6875 19.5C32.6875 17.9062 33.9062 16.5 35.5938 16.5ZM42.9062 0C46.2812 0 48.9062 2.71875 48.9062 6V32.8125C48.9062 36 46.1875 38.7188 42.9062 38.7188H29.4062L17.6875 47.5312C16.9375 48 15.9062 47.5312 15.9062 46.5938V38.8125H6.90625C3.53125 38.8125 0.90625 36.1875 0.90625 32.9062V6C0.90625 2.71875 3.53125 0 6.90625 0H42.9062ZM44.5 33V6C44.5 5.25 43.75 4.5 43 4.5H7C6.15625 4.5 5.5 5.25 5.5 6V33C5.5 33.8438 6.15625 34.5 7 34.5H20.5V40.125L28 34.5H43C43.75 34.5 44.5 33.8438 44.5 33Z",
    fill: "#193154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.86dac78d1a7c7ee0df9f1106aac3253d.svg";
export { ForwardRef as ReactComponent };